<app-demographics *ngIf="patient && patient.id" [patient]="patient"></app-demographics>
